export default __webpack_public_path__ + "static/media/estrutura1.fc31f83b.jpg";